import * as THREE from "three";
import * as TWEEN from "@tweenjs/tween.js";

export class ViewManager {
  constructor() {
    this.renderer = new THREE.WebGLRenderer({
      antialias: true,
      stencil: false,
      depth: true,
      alpha: true,
    });
    this.renderer.outputColorSpace = THREE.SRGBColorSpace;
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setScissorTest(true);
    this.renderer.setAnimationLoop((time) => this.animate(time));
    this.views = {};
  }

  dispose() {
    for (const view of Object.values(this.views)) {
      view.dispose();
    }
    this.views = {};
  }

  getView(id) {
    if (this.views[id]) {
      return this.views[id];
    }
    return null;
  }

  addView(view) {
    this.views[view.id] = view;
  }

  removeView(view) {
    if (view) {
      view.dispose();
      delete this.views[view.id];
    }
  }

  animate(time) {
    TWEEN.update(time);
    for (const view of Object.values(this.views)) {
      view.render();
    }
  }
}
